
import { JsonConverter, JsonCustomConvert } from 'json2typescript';

@JsonConverter
export default class UpperCaseConverter implements JsonCustomConvert<string> {
  public serialize(vehicle:string): any {
    return vehicle;
  }

  // A value that is not a mode name is dropped rather than thrown on: it would fail
  // the mapping of the whole payload over one malformed field
  public deserialize(vehicle:string):string {
    return typeof vehicle === 'string' ? vehicle.toUpperCase() : undefined;
  }
}